module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-6-07d6f9a700f1b0c6daff40f1d9f7e4a1.jpg";